import { SelectInput, TextInput, required, useTranslate } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { Box, Stack } from '@mui/material';
import { LINK_CONFIG_KEYS } from './link-config-keys';

const APK_URL_PATTERN = /^https:\/\/cdn\.xbit\.com\/releases\/XBIT_APP_v.+\.apk$/;

interface FormProps {
  isCreate: boolean;
}

const LinkConfigForm = ({ isCreate }: FormProps) => {
  const t = useTranslate();
  const selectedKey = useWatch({ name: 'key' });

  const validateApkUrl = (value: string) => {
    if (!value) return undefined;
    if (!APK_URL_PATTERN.test(value.trim())) {
      return t('module.linkConfig.validate.valueInvalidApkUrl', {
        pattern: 'https://cdn.xbit.com/releases/XBIT_APP_v*.apk',
      });
    }
    return undefined;
  };

  const validate =
    selectedKey === 'url_apk'
      ? [required(t('module.linkConfig.validate.valueRequired')), validateApkUrl]
      : [required(t('module.linkConfig.validate.valueRequired'))];

  return (
    <>
      <Box>
        <Stack>
          <SelectInput
            source="key"
            label="module.linkConfig.key"
            choices={LINK_CONFIG_KEYS}
            validate={[required(t('module.linkConfig.validate.keyRequired'))]}
            disabled={!isCreate}
            fullWidth
          />
          <TextInput source="value" validate={validate} fullWidth />
        </Stack>
      </Box>
    </>
  );
};

export default LinkConfigForm;
